import { render, staticRenderFns } from "./cModalcommet.vue?vue&type=template&id=2e28e29c"
import script from "./cModalcommet.vue?vue&type=script&lang=js"
export * from "./cModalcommet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports